import React from 'react'

import { useIsNodeContentTruncated } from '@sketch/utils'

import { Tooltip } from '@sketch/components'

import { privacyIcon } from '../ProjectListItem/ProjectListItem.utils'

import {
  DisabledProject,
  DisabledProjectName,
  Icon,
} from './ProjectsList.styles'

import { ProjectFragment } from '@sketch/gql-types'

interface DisabledProjectItemsProps {
  project: ProjectFragment
}

/**
 *
 * DisabledProjectItem
 *
 * Renders a disabled version of a Project item used in the Sidebar for the projects section
 */
const DisabledProjectItem: React.FCC<DisabledProjectItemsProps> = ({
  project,
}) => {
  const [isNodeContentTruncated, truncatedNodeRef] = useIsNodeContentTruncated()
  const { component: icon, label } = privacyIcon(project)

  return (
    <Tooltip
      key={project.identifier}
      placement="right"
      content={project.name}
      disabled={!isNodeContentTruncated}
    >
      <DisabledProject aria-disabled="true">
        <Icon as={icon} aria-label={label} />{' '}
        <DisabledProjectName ref={truncatedNodeRef}>
          {project.name}
        </DisabledProjectName>
      </DisabledProject>
    </Tooltip>
  )
}

export default DisabledProjectItem
